import picModal from './picModal.vue'
export default picModal



// WEBPACK FOOTER //
// ./src/components/picModal/index.js